import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, interval, Observable, of, Subject, throwError } from 'rxjs';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CompanyInterface } from '../company';
import { catchError, map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { getAuth, signInWithCustomToken, signOut } from 'firebase/auth';
import { AngularFireDatabase } from '@angular/fire/compat/database';

// const url = 'http://localhost:3300/v1 '

@Injectable({
  providedIn: 'root'
})
export class CustomerDataService {
  rtdbRef: any;
  list: any = [];
  message = new BehaviorSubject([]);

  private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public refresh = new Subject()
  role$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  userId$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  isTabActive$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor(private http: HttpClient,
    private firestore: AngularFirestore,
    private router: Router,
    private firebase: AngularFireDatabase) {
    this.rtdbRef = this.firebase.database.app.database().ref('/');
  }

  signup(user: any): Observable<any> {
    return this.http.post<any>('api/v1/admin/Register', user).pipe(catchError(this.Errorhandler));
  }

  loginform(data: any): Observable<any> {
    if (data.email !== '' && data.password !== '') {
      this.loggedIn.next(true);
      this.router.navigate(['/customers']);

    }
    return this.http.post<any>('api/v1/admin/login-form', data).pipe(catchError(this.Errorhandler));

  }

  requestReset(body: any): Observable<any> {
    console.log(body)
    return this.http.post('api/v1/admin/req-reset-password', body).pipe(catchError(this.Errorhandler));
  }
  hello(): Observable<any> {
    return this.http.post('api/v1/admin/check-status1', { initial: 'true' }).pipe(catchError(this.Errorhandler));

  }

  setCompanies(list: []): void {
    this.list = list;
    this.message.next(this.list);
  }
  fetchcompanies(): any[] {
    return this.list;
  }
  setcompany(data: any): void {
    this.list.push(data);
    this.message.next(this.list);
  }
  update(data: any, index: number): any {
    this.list[index] = data;
    this.message.next(this.list);
  }





  createUserData(record: any): Observable<any> {
    // return this.firestore.collection('admins').doc(`${mail}`).set(record)
    return this.http.post<any>('api/v1/admin/addUser', record).pipe(catchError(this.Errorhandler));

  }
  getAllDetails(): any {
    return this.firestore.collection('admins').snapshotChanges();
  }

  updateUserData(updatedUserData: any): Observable<any> {
    return this.http.post<any>('api/v1/admin/updateUser', updatedUserData).pipe(catchError(this.Errorhandler));
    // this.firestore.doc('admins/' + recordid).update(record);
  }

  deleteUser(userId: any): Observable<any> {
    console.log(userId)
    // this.firestore.doc('admins/' + recordid).delete();
    return this.http.post<any>('api/v1/admin/deleteUser', userId).pipe(catchError(this.Errorhandler));

  }


  Errorhandler(errorRes: HttpErrorResponse) {
    let errorMessage = 'An Error Occurred';
    if (!errorRes.error || !errorRes.error.message) {
      return throwError(errorMessage)
    }
    switch (errorRes.error.message) {
      case 'Email  Already Registered':
        errorMessage = 'Email  Already Exists'
    }
    errorMessage = errorRes.error.message
    return throwError(errorMessage);
    // return throwError(error.error.message || 'server error');
  }

}


